/**
 * PageContainer Component
 * 
 * Wrapper component providing consistent page spacing and layout.
 */

import React from 'react';

export interface PageContainerProps {
  /** Page content */
  children: React.ReactNode;
  /** Additional CSS classes */
  className?: string;
}

export function PageContainer({ children, className = '' }: PageContainerProps) {
  return (
    <div className={`space-y-6 ${className}`}>
      {children}
    </div>
  );
}
